import React from 'react';

import './WarehouseEvents.css'
import Button from 'react-bootstrap/Button';
import axios from 'axios';
import { downloadFromUrl } from './helpers';

class WarehouseEvents extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
    }
  }

  exportFile = async (selection) => {
    const { data } = await axios.get(`/api/warehouse_events/export?warehouse=${selection.warehouse.toLowerCase()}`);

    downloadFromUrl(data.url);
  }

  render() {
    return (
      <div className="warehouse-events-container">
        <div className="warehouse-events-title">Warehouse Events</div>

        <div className="warehouse-events-section">
          <span className="warehouse-events-subtitle">3PL</span>
          <Button className="warehouse-events-button" variant="info" onClick={() => this.exportFile({warehouse: '3pl', format: 'csv'})}>Export</Button>
        </div>

        <div className="warehouse-events-section">
          <span className="warehouse-events-subtitle">Champion</span>
          <Button className="warehouse-events-button" variant="info" onClick={() => this.exportFile({warehouse: 'champion', format: 'csv'})}>Export</Button>
        </div>

        <div className="warehouse-events-section">
          <span className="warehouse-events-subtitle">3PL Links</span>
          <Button className="warehouse-events-button" variant="info" onClick={() => this.exportFile({warehouse: '3pllinks', format: 'csv'})}>Export</Button>
        </div>

      </div>
    );
  }
}

export default WarehouseEvents;
